/**
 * @generated SignedSource<<b2d1d749720ec268d8d9f027a64e4d20>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type PopupImportJobStatus = "QUEUED" | "RUNNING" | "COMPLETED" | "COMPLETED_WITH_ERRORS" | "FAILED" | "%future added value";
export type PopupListPageLatestJobQuery$variables = {};
export type PopupListPageLatestJobQueryVariables = PopupListPageLatestJobQuery$variables;
export type PopupListPageLatestJobQuery$data = {
  readonly latestPopupImportJob: {
    readonly slug: string;
    readonly status: PopupImportJobStatus;
    readonly totalCount: number;
    readonly succeededCount: number;
    readonly failedCount: number;
    readonly retryCsv: string | null;
    readonly errorMessage: string | null;
  } | null;
};
export type PopupListPageLatestJobQueryResponse = PopupListPageLatestJobQuery$data;
export type PopupListPageLatestJobQuery = {
  variables: PopupListPageLatestJobQueryVariables;
  response: PopupListPageLatestJobQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "succeededCount",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "failedCount",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "retryCsv",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errorMessage",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PopupListPageLatestJobQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PopupImportJob",
        "kind": "LinkedField",
        "name": "latestPopupImportJob",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "PopupListPageLatestJobQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PopupImportJob",
        "kind": "LinkedField",
        "name": "latestPopupImportJob",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b22a69f06c754356a34479872a2660bd",
    "id": null,
    "metadata": {},
    "name": "PopupListPageLatestJobQuery",
    "operationKind": "query",
    "text": "query PopupListPageLatestJobQuery {\n  latestPopupImportJob {\n    slug\n    status\n    totalCount\n    succeededCount\n    failedCount\n    retryCsv\n    errorMessage\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "e14f5af48985a041955ce42c9d6b9ea8";

export default node;
